
export default {
  methods: {
    labelForProductStatus(status) {
      switch (status) {
        case 'InStock':
          return 'In stock';
        case 'OutOfStock':
          return 'Out of stock';
        case 'InProduction':
          return 'In production';
        default:
          return 'Unknown product status';
      }
    },
  },
};
